// extracted by mini-css-extract-plugin
export default {"root":"doc-item_root__HvmeY","label":"doc-item_label__za6LJ","date":"doc-item_date__johDs","action":"doc-item_action__PlYtt","download":"doc-item_download__eNlBn"};